<div class="container-fluid">
  <div class="card">
    <div class="d-flex flex-row justify-content-end form-group mt-2 mb-5">
      <div>
        <button (click)="back()" class="btn btn-standard action-btn" type="button">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
    </div>
    <div class="card-body text-center">
      <h2 class="d-inline">{{ settlementBatch?.batchNumber }} -</h2>
            <h2 [ngClass]=" {
            'text-primary': settlementBatch?.batchStatus == 'OPEN',
            'text-success': settlementBatch?.batchStatus == 'SETTLED',
            'text-info': settlementBatch?.batchStatus == 'CLOSED',
            'text-danger': settlementBatch?.batchStatus == 'ERROR' }" class="d-inline">
      {{ settlementBatch?.batchStatus | getBatchStatusDescription }} </h2>

      <table class="table table-hover table-responsive-md">
        <thead>
          <tr>
            <th scope="col">Date Created</th>
            <th scope="col">Account Number</th>
            <th scope="col">Reference</th>
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            <th scope="col">Amount</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody class="table-hover text-nowrap">
          @for (account of accounts; track account) {
            <tr class="cursor-pointer  active-color">
              <td (click)="view(account)">{{ account.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}</td>
              <td (click)="view(account)">{{ account.accountNumber | accountNumberSansMerchantPrefix }}</td>
              <td (click)="view(account)">{{ account.referenceNumber }}</td>
              <td (click)="view(account)">{{ account.customer }}</td>
              <td (click)="view(account)">{{ account.customerEmail }}</td>
              <td (click)="view(account)">{{ account.amountPaid | toMajor | currency:'R ' }}</td>
              <td (click)="view(account)"
                [ngClass]="getAccountStatusUtil().getAccountTextColorClass(account.accountState)">
                {{ account.accountState | getAccountStatusDescription }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>